import { useQuery } from '@tanstack/react-query';
import {
  getPurchaseOrders, type POFilters 
} from '../api';

export function usePurchaseOrders(filters?: POFilters) {
  return useQuery({
    queryKey: ['purchaseOrders', filters],
    queryFn: () => getPurchaseOrders(filters),
    staleTime: 30_000,
  });
}
